import app from './app';

class ContentBlocker {

    constructor() {
        this.body = document.body;
        this.pageOffset = 0;
        this._isBlocked = false;
        this._isOverlapped = false;
        this.sources = {};
        this.overlap = {};
    }

    block(source, overlap = false) {
        this.sources[source] = true;
        this.overlap[source] = overlap;
        if (!this._isBlocked) {
            if (app.isTouch) {
                this.pageOffset = window.pageYOffset;
                this.body.classList.add('is-blocked-touch');
                this.body.style.top = -this.pageOffset + 'px';
            } else {
                this.body.classList.add('is-blocked');
            }
            this._isBlocked = true;
        }
        if (!this._isOverlapped && overlap) {
            this.body.classList.add('is-overlapped');
            this._isOverlapped = true;
        }
    }

    unblock(source) {
        this.sources[source] = false;
        this.overlap[source] = false;
        if (this.isFree() && this._isBlocked) {
            if (app.isTouch) {
                this.body.style.top = 'initial';
                this.body.classList.remove('is-blocked-touch');
                window.scrollTo(0, this.pageOffset);
            } else {
                this.body.classList.remove('is-blocked');
            }
            this._isBlocked = false;
        }
        if (this.isNotOverlapped() && this._isOverlapped) {
            this.body.classList.remove('is-overlapped');
            this._isOverlapped = false;
        }
    }

    isBlocked(source) {
        return this.sources[source] === true;
    }

    isFree() {
        return Object.keys(this.sources).every(key => this.sources[key] === false);
    }

    isNotOverlapped() {
        return Object.keys(this.overlap).every(key => this.overlap[key] === false);
    }
}

let instance = new ContentBlocker();

export default instance;




// WEBPACK FOOTER //
// ./app/general/js/content-blocker.js